var _rect, _circle, _circle2, _rect2, _rect3, _g, _text, _text2, _rect4, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800,
    height: 1000,
    viewBox: "0 0 800 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bg",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1e3a5f",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#0f6b8e",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accent",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#3b9fd4",
      stopOpacity: 0.6
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#3b9fd4",
      stopOpacity: 0
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 800,
    height: 1000,
    fill: "url(#bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 650,
    cy: 150,
    r: 200,
    fill: "#ffffff",
    fillOpacity: 0.04
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 150,
    cy: 850,
    r: 250,
    fill: "#ffffff",
    fillOpacity: 0.04
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 400,
    width: 300,
    height: 2,
    fill: "url(#accent)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 500,
    width: 200,
    height: 2,
    fill: "url(#accent)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(280, 300)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 80,
    width: 160,
    height: 120,
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 55,
    y: 80,
    width: 8,
    height: 120,
    fill: "#ffffff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80,
    y: 80,
    width: 8,
    height: 120,
    fill: "#ffffff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105,
    y: 80,
    width: 8,
    height: 120,
    fill: "#ffffff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 80,
    width: 8,
    height: 120,
    fill: "#ffffff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155,
    y: 80,
    width: 8,
    height: 120,
    fill: "#ffffff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 80,
    width: 8,
    height: 120,
    fill: "#ffffff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "20,80 120,20 220,80",
    fill: "none",
    stroke: "#ffffff",
    strokeWidth: 2,
    strokeOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 95,
    y: 140,
    width: 50,
    height: 60,
    fill: "#ffffff",
    fillOpacity: 0.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 200,
    width: 200,
    height: 8,
    fill: "#ffffff",
    fillOpacity: 0.4
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 560,
    fontFamily: "Georgia, serif",
    fontSize: 36,
    fontWeight: "bold",
    fill: "#ffffff",
    fillOpacity: 0.95,
    textAnchor: "middle",
    letterSpacing: 4
  }, "QUALIFIA")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 595,
    fontFamily: "Arial, sans-serif",
    fontSize: 13,
    fill: "#ffffff",
    fillOpacity: 0.6,
    textAnchor: "middle",
    letterSpacing: 2
  }, "PARTENARIATO PUBBLICO PRIVATO")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 300,
    y: 610,
    width: 200,
    height: 1,
    fill: "#3b9fd4",
    fillOpacity: 0.7
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 400,
    y: 650,
    fontFamily: "Arial, sans-serif",
    fontSize: 11,
    fill: "#ffffff",
    fillOpacity: 0.4,
    textAnchor: "middle"
  }, "D.lgs 36/2023 \xB7 D.lgs 209/2024")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBg);
export default __webpack_public_path__ + "static/media/login-bg.3ce8ca07f13ffaf09ca407e5b1f4ab5c.svg";
export { ForwardRef as ReactComponent };